<app-grafana-embed
  [src]="grafanaOverview"
  [height]="900"
></app-grafana-embed>
